import classNames from 'classnames';
import styles from './tag.module.sass';

export const Tag = ({ id, label, checked, idx, setActiveTag }: ITag) => {
  return (
    <div
      className={classNames(styles.tag, checked && styles.tag__checked)}
      key={id}
      onClick={() => setActiveTag(idx)}
    >
      {' '}
      {label}{' '}
    </div>
  );
};

interface ITag {
  id: number | string;
  label: string;
  checked: boolean;
  idx: number;
  setActiveTag: (idx: number) => void;
}
